import { SVGProps } from "react";
const CryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
      fill="#FFD93B"
    />
    <path
      d="M35 20c0 8.288-6.716 15-15 15a14.97 14.97 0 0 1-11.676-5.582 14.92 14.92 0 0 0 9.417 3.323c8.283 0 15-6.712 15-15 0-3.567-1.242-6.843-3.323-9.417a14.98 14.98 0 0 1 5.583 11.677"
      fill="#F4C534"
    />
    <path
      d="M20.896 17.58c.496 2.592 3.183 4.528 6 4.316 2.828-.213 4.707-2.493 4.21-5.085-.498-2.6-3.183-4.528-6.01-4.315-2.818.211-4.698 2.483-4.2 5.084"
      fill="#fff"
    />
    <path
      d="M24.734 19.188a2.328 2.328 0 1 0 0-4.656 2.328 2.328 0 0 0 0 4.656"
      fill="#3E4347"
    />
    <path
      d="M24.43 15.497c-.18-.181-.566-.09-.86.204-.293.293-.384.678-.203.86.181.18.566.09.86-.204s.385-.678.203-.86m-5.325 2.083c-.495 2.592-3.182 4.528-6 4.316-2.827-.213-4.706-2.493-4.209-5.085.498-2.6 3.183-4.528 6.01-4.315 2.818.211 4.697 2.483 4.2 5.084"
      fill="#fff"
    />
    <path
      d="M15.265 19.188a2.328 2.328 0 1 0 0-4.656 2.328 2.328 0 0 0 0 4.656"
      fill="#3E4347"
    />
    <path
      d="M14.962 15.496c-.181-.181-.566-.09-.86.204-.294.293-.385.678-.204.86.182.18.567.09.86-.204s.385-.679.204-.86"
      fill="#fff"
    />
    <path
      d="M9.5 12.47s5.03 1.032 8.812-2.047Q17.193 15.03 9.5 12.469m21 .001s-5.032 1.032-8.812-2.047q1.117 4.607 8.811 2.046M15.142 29.011c1.003-1.856 2.803-3.093 4.866-3.093 2.053 0 3.853 1.228 4.847 3.075.337.628 1.284.262 1.106-.432-.647-2.596-2.972-4.668-5.953-4.668-2.991 0-5.325 2.08-5.972 4.678-.169.694.769 1.06 1.106.44"
      fill="#3E4347"
    />
    <path
      d="M9.398 19.729c.098-.02.205-.037.342-.037.778 0 .778.408 1.555.408s.776-.408 1.553-.408.777.408 1.553.408.776-.408 1.552-.408.776.408 1.551.408c.109 0 .199-.01.281-.022-1.156 1.217-2.888 1.953-4.678 1.817-1.663-.124-2.992-.967-3.709-2.166"
      fill="#59A5E0"
    />
    <path
      d="M9.086 22.306c.047.542.39.925.916.925.54 0 .79-.662.635-1.059-.412-1.049-.65-2.077-.65-2.077s-.863 1.373-.901 2.211m.25 3.358c.026.304.223.567.518.567.303 0 .481-.344.353-.642-.251-.581-.368-1.032-.368-1.032s-.482.636-.503 1.107"
      fill="#59A5E0"
    />
    <path
      d="M10.065 25.806c.047.028.028.103-.037.178-.066.075-.15.103-.197.075s-.028-.113.037-.178c.066-.075.15-.113.197-.075m.217-2.964c-.122.132-.272.197-.347.141-.085-.047-.066-.197.056-.328.112-.131.272-.188.356-.131.075.056.047.197-.066.318"
      fill="#fff"
    />
  </svg>
);
export default CryIcon;
